import React, { useState } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import { useCompanyContext } from "../hooks/useCompanyContext";

const FileUpload = ({ user, onUploadSuccess }) => {
  const [category, setCategory] = useState("GlobalGap");
  const [orderNo, setOrderNo] = useState("");
  const [title, setTitle] = useState("");
  const [partijKoppeling, setPartijKoppeling] = useState("order");
  const [uploading, setUploading] = useState(false);

  const { company } = useCompanyContext();
  const { t } = useCompanyContext();

  const orderNumbers =
    company?.orders
      ?.map((order) => order.No)
      ?.sort((a, b) => {
        const numA = parseInt(a.replace(/\D/g, ""), 10);
        const numB = parseInt(b.replace(/\D/g, ""), 10);
        return numB - numA;
      }) || [];

  const onDrop = async (acceptedFiles) => {
    const file = acceptedFiles[0];
    const companyid = company?.Companyid;

    if (!companyid) {
      alert("❌ Geen bedrijf geselecteerd.");
      return;
    }

    if (category === "GlobalGap" && !orderNo) {
      alert("Selecteer een ordernummer.");
      return;
    }

    if (category === "Partij informatie" && partijKoppeling === "order" && !orderNo) {
      alert("Selecteer een ordernummer of kies voor titel.");
      return;
    }

    if (
      (category === "Algemeen" ||
        (category === "Partij informatie" && partijKoppeling === "titel")) &&
      !title.trim()
    ) {
      alert("Geef een titel op.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("category", category);
    formData.append("companyid", companyid);

    if (category === "Algemeen") {
      formData.append("title", title.trim());
    }

    if (category === "GlobalGap") {
      formData.append("order_no", orderNo);
    }

    if (category === "Partij informatie") {
      if (partijKoppeling === "order") {
        formData.append("order_no", orderNo);
      } else {
        formData.append("title", title.trim());
      }
    }

    setUploading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/documents/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      alert("✅ Bestand succesvol geüpload!");

      setOrderNo("");
      setTitle("");

      if (onUploadSuccess) {
        onUploadSuccess(res.data);
      }
    } catch (error) {
      console.error("❌ Upload mislukt:", error);
      alert("❌ Upload mislukt, probeer opnieuw.");
    } finally {
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  if (!user.roles || !user.roles.includes("medewerker")) return null;

  return (
    <div>
      <h3 className="pageheading">Bestand Uploaden</h3>

      <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
        <div>
          <select
            className="upload-select"
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
              setOrderNo("");
              setTitle("");
              setPartijKoppeling("order");
            }}
          >
            <option value="GlobalGap">GlobalGap</option>
            <option value="Partij informatie">{t.partijInformatie}</option>
            <option value="Algemeen">{t.algemeen}</option>
          </select>
        </div>

        {category === "Partij informatie" && (
          <div>
            <select
              className="upload-select"
              value={partijKoppeling}
              onChange={(e) => {
                setPartijKoppeling(e.target.value);
                setOrderNo("");
                setTitle("");
              }}
            >
              <option value="order">Ordernummer</option>
              <option value="titel">Titel</option>
            </select>
          </div>
        )}

        {(category === "GlobalGap" ||
          (category === "Partij informatie" && partijKoppeling === "order")) && (
          <div>
            <select
              className="upload-select"
              value={orderNo}
              onChange={(e) => setOrderNo(e.target.value)}
              disabled={orderNumbers.length === 0}
            >
              <option value="" disabled>
                {orderNumbers.length > 0
                  ? "-- Selecteer ordernummer --"
                  : "Geen ordernummers beschikbaar"}
              </option>

              {orderNumbers.map((no) => (
                <option key={no} value={no}>
                  {no}
                </option>
              ))}
            </select>
          </div>
        )}

        {(category === "Algemeen" ||
          (category === "Partij informatie" && partijKoppeling === "titel")) && (
          <div className="search-container" style={{ marginBottom: 0 }}>
            <input
              className="search-input"
              type="text"
              placeholder="Titel"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        )}
      </div>

      <div
        {...getRootProps()}
        style={{
          border: "2px dashed gray",
          padding: "10px",
          margin: "30px",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        <p>{uploading ? "📤 Bestand wordt geüpload..." : "Klik of sleep om te uploaden"}</p>
      </div>
    </div>
  );
};

export default FileUpload;